
        <template>
          <div class="vc-snippet-doc">
            <h1>Button 按钮</h1>
<p>按钮用于开始一个即时操作。</p>
<h2>基础用法</h2>
<vc-snippet>
                  <div slot="desc"><p>通过 <code>v-button</code> 标签初始化按钮。</p>
</div>
                  <vc-snippent-0 slot="source" />
                  <div slot="code"><pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">v-button</span>&gt;</span>Default<span class="hljs-tag">&lt;/<span class="hljs-name">v-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
</code></pre>
    </div>
                </vc-snippet> <h2>文本设置</h2>
<vc-snippet>
                  <div slot="desc"><p>通过 <code>text</code> 设置按钮文本。</p>
</div>
                  <vc-snippent-1 slot="source" />
                  <div slot="code"><pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">v-button</span> <span class="hljs-attr">text</span>=<span class="hljs-string">"Default"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">v-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
</code></pre>
    </div>
                </vc-snippet> <h2>事件绑定</h2>
<vc-snippet>
                  <div slot="desc"><p>绑定 <code>click</code> 事件。</p>
</div>
                  <vc-snippent-2 slot="source" />
                  <div slot="code"><pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">v-button</span> <span class="hljs-attr">text</span>=<span class="hljs-string">"Default"</span> @<span class="hljs-attr">click</span>=<span class="hljs-string">"handleButtonClick"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">v-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-attr">methods</span>: {
      handleButtonClick() {
        alert(<span class="hljs-number">1</span>);
      },
    },
  };
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
    </div>
                </vc-snippet> <h2>JSX 语法支持</h2>
<vc-snippet>
                  <div slot="desc"><p>示例代码支持<code>jsx</code>渲染。</p>
</div>
                  <vc-snippent-3 slot="source" />
                  <div slot="code"><pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    render() {
      <span class="hljs-keyword">return</span> (
        <span class="xml"><span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">v-button</span>
            <span class="hljs-attr">text</span>=<span class="hljs-string">"Default"</span>
            <span class="hljs-attr">onClick</span>=<span class="hljs-string">{()</span> =&gt;</span> {
              this.handleButtonClick();
            }}
          &gt;<span class="hljs-tag">&lt;/<span class="hljs-name">v-button</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span></span>
      );
    },
    <span class="hljs-attr">methods</span>: {
      handleButtonClick() {
        alert(<span class="hljs-number">1</span>);
      },
    },
  };
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
    </div>
                </vc-snippet> <h2>Button Attributes</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>text</td>
<td>按钮文本</td>
<td>String</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h2>Button Events</h2>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>click</td>
<td>单击触发</td>
<td>event</td>
</tr>
</tbody>
</table>
<h2>Button Slots</h2>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>—</td>
<td>按钮内容</td>
</tr>
</tbody>
</table>

          </div>
        </template>
        <script>
           //
//
//
//
//
// 
           export default {
           name: 'vc-component-doc',
           components: {
            "vc-snippent-0":(function () {
          var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-button',[_vm._v("Default")])],1)}
var staticRenderFns = []

          const exportJavaScript = {};
           return {
             ...exportJavaScript,
            render, 
            staticRenderFns,   
          }
        })(),"vc-snippent-1":(function () {
          var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-button',{attrs:{"text":"Default"}})],1)}
var staticRenderFns = []

          const exportJavaScript = {};
           return {
             ...exportJavaScript,
            render, 
            staticRenderFns,   
          }
        })(),"vc-snippent-2":(function () {
          var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-button',{attrs:{"text":"Default"},on:{"click":_vm.handleButtonClick}})],1)}
var staticRenderFns = []

          const exportJavaScript =  {
  methods: {
    handleButtonClick() {
      alert(1);
    },
  },
};

           return {
             ...exportJavaScript,
            render, 
            staticRenderFns,   
          }
        })(),"vc-snippent-3":(function () {
          
          const exportJavaScript =  {
  render() {
    return (
      <div>
        <v-button
          text="Default"
          onClick={() => {
            this.handleButtonClick();
          }}
        ></v-button>
      </div>
    );
  },
  methods: {
    handleButtonClick() {
      alert(1);
    },
  },
};

           return {
             ...exportJavaScript,
             
               
          }
        })()
           }
         }
       </script>
       <style lang='scss'>
         
       </style>